export enum AboutUsSection {
  TOP = 'about-us-top',
  DESCRIPTION = 'about-us-description',
  PILLARS = 'about-us-pillars',
  OUR_BRANDS = 'about-us-brands',
}
